import { render } from "./QuestionsTab.vue?vue&type=template&id=18021656&scoped=true"
import script from "./QuestionsTab.vue?vue&type=script&lang=ts"
export * from "./QuestionsTab.vue?vue&type=script&lang=ts"

import "./QuestionsTab.vue?vue&type=style&index=0&id=18021656&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18021656"

export default script